import React from 'react';
import cn from './../../lib/bem/index';
import { useSelector, useDispatch } from "react-redux";
import { formatAmount, removeFormatNumber } from './../../lib/utils/index';
import { updateMonto, postCotizarSimulacion, updateMontosResp, postCaptcha } from './../../redux/reducers/simuladorFVGSlice';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import './montoInput_component.scss';

const MontoInputComponent = () => {

    const classes = cn("montoInputComponent");
    const dispatch = useDispatch();

    const { executeRecaptcha } = useGoogleReCaptcha();

    const simuladorFVG    = useSelector((state) => state.rootReducers.simuladorFVG);

    const onChangeMonto = (value) => {
        dispatch(updateMonto({
            'monto' : formatAmount(value)
        }));
    }   

    const onBlurMonto = async () => {
		
		const token = await executeRecaptcha('ecowebapp');

        var param = simuladorFVG.parametros.filter( item => item.plazo === parseInt(simuladorFVG.plazo) && item.moneda === simuladorFVG.moneda );
        var montoMinimo = param.length > 0 ? param[0].montoMinimo : 0;
        var montoMaximo = param.length > 0 ? param[0].montoMaximo : 0;

        var monto   = simuladorFVG.monto === "" ? 0 : parseFloat(removeFormatNumber(simuladorFVG.monto));

        if( monto >= parseFloat(montoMinimo) && monto <= parseFloat(montoMaximo) ){
            dispatch(updateMonto({
                'monto' : formatAmount(simuladorFVG.monto,"blur")
            }));

            if(process.env.REACT_APP_ACTIVE_VALIDATION_RECAPTCHA === 'true'){
                dispatch(postCaptcha(
                    token
                )).then((resp) => { 
                    if(resp.payload.datos.esValido){
                        dispatch(postCotizarSimulacion({
                            "idSimulacion"  : simuladorFVG.idSimulacion,
                            "moneda"        : simuladorFVG.moneda,
                            "monto"         : monto,
                            "plazo"         : simuladorFVG.plazo
                        }));
                    }
                });
            } else {
                dispatch(postCotizarSimulacion({
                    "idSimulacion"  : simuladorFVG.idSimulacion,
                    "moneda"        : simuladorFVG.moneda,
                    "monto"         : monto,
                    "plazo"         : simuladorFVG.plazo
                }));
            }

        } else {
            dispatch(updateMonto({
                'monto' : ''
            }));
            dispatch(updateMontosResp());
        }
    }

    const tipoMoneda = simuladorFVG.moneda === 'S' ? 'S/' : 'US$';
    const valorMonto = simuladorFVG.monto === '' ? `${tipoMoneda} ` : `${tipoMoneda} ${simuladorFVG.monto}`;

    const mostrarMontosDesde = () => {
        var param = simuladorFVG.parametros.filter( item => item.plazo === parseInt(simuladorFVG.plazo) && item.moneda === simuladorFVG.moneda );
        return param.length > 0 ? monedaSimbolo() + formatAmount(param[0].montoMinimo + '') : '';
    }

    const mostrarMontosHasta = () => {
        var param = simuladorFVG.parametros.filter( item => item.plazo === parseInt(simuladorFVG.plazo) && item.moneda === simuladorFVG.moneda );
        return param.length > 0 ? monedaSimbolo() + formatAmount(param[0].montoMaximo + '') : '';
    }

    const monedaSimbolo = () => { return simuladorFVG.moneda === 'S' ? 'S/ ' : 'US$ ' };


    return (
        <div className={classes()}> 
            <div>
                <p className={classes('montoInputComponent_text')}>Monto a invertir</p>
                <p className={classes('montoInputComponent_sub_text')}>Desde { mostrarMontosDesde() } hasta { mostrarMontosHasta() }</p>
            </div>
            <div>
                <input name="txtMonto" value={valorMonto} onChange={ (e) => onChangeMonto(e.target.value)} onBlur={ () => onBlurMonto() } autoComplete="off" />
            </div>
        </div>
    );
};

export default MontoInputComponent;